import { StrictExtract } from '@noths/polaris-dev-ts-recipes';

import { ProgressMilestones, TrackedEvents } from 'src/redux/personalisation';
import { ProductOption } from 'src/types';

const MILESTONE_50: StrictExtract<ProgressMilestones, 'Progress - 50%'> = 'Progress - 50%';
const MILESTONE_100: StrictExtract<ProgressMilestones, 'Progress - 100%'> = 'Progress - 100%';
interface GetMilestonesFnParam extends Pick<GetProgressMilestoneFnParam, 'trackedEvents'> {
  progress: number;
}

const getMilestones = ({ trackedEvents, progress }: GetMilestonesFnParam) => {
  const is50Milestone = progress >= 50 && progress <= 99 && !trackedEvents.progress[MILESTONE_50];

  const is100Milestone = progress === 100 && !trackedEvents.progress[MILESTONE_100];

  return { is50Milestone, is100Milestone };
};

interface GetProgressMilestoneFnParam {
  totalRequiredPersonalisations: number;
  totalOutstandingSelections: number;
  trackedEvents: TrackedEvents;
  fieldName: string;
  isRequiredPersonalisation: boolean;
}

export const getProgressMilestone = ({
  totalRequiredPersonalisations,
  totalOutstandingSelections,
  trackedEvents,
  fieldName,
  isRequiredPersonalisation,
}: GetProgressMilestoneFnParam) => {
  if (!isRequiredPersonalisation) {
    return null;
  }

  const outstandingPersonalisationsTotal =
    // `- 1` modifier accommodates new selections, which Store state's outstandingTotal doesn't reflect.
    trackedEvents.progress[fieldName] == null
      ? totalOutstandingSelections - 1
      : totalOutstandingSelections;

  const progress = Math.floor(
    (100 / totalRequiredPersonalisations) *
      (totalRequiredPersonalisations - outstandingPersonalisationsTotal),
  );

  const { is50Milestone, is100Milestone } = getMilestones({ trackedEvents, progress });

  if (is50Milestone) {
    return MILESTONE_50;
  } else if (is100Milestone) {
    return MILESTONE_100;
  }

  return null;
};

export const getFieldPosition = (options: ProductOption[], option: Pick<ProductOption, 'id'>) =>
  options.findIndex((opt) => opt.id === option.id) + 1;
